import React from 'react';

const InstagramOutlinedBlue = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.66 1.5a2.875 2.875 0 0 0-2.874 2.875v7.25a2.875 2.875 0 0 0 2.874 2.874h7.25a2.875 2.875 0 0 0 2.875-2.875v-7.25A2.875 2.875 0 0 0 11.91 1.5zM.286 4.375A4.375 4.375 0 0 1 4.66 0h7.25a4.375 4.375 0 0 1 4.375 4.375v7.25a4.375 4.375 0 0 1-4.375 4.374H4.66a4.375 4.375 0 0 1-4.374-4.375zm8.347 1.468a2.15 2.15 0 1 0-.63 4.253 2.15 2.15 0 0 0 .63-4.253M6.637 4.73a3.65 3.65 0 1 1 3.362 6.479 3.65 3.65 0 0 1-3.362-6.48m5.637-1.467a.75.75 0 0 0 0 1.5h.006a.75.75 0 0 0 0-1.5z"
            fill="#009FDF"
        />
    </svg>
);
export default InstagramOutlinedBlue;
